import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../../../APIHelpers/Responses";

export const eiwrsKitPreparationServices = {
  //Kit Preparation Management
  addNewStudyKitPreparation,
  updateStudyKitPreparation,
  statusConvertKitPreparation,
  approvedDispatchedKitPreparation,
  deleteStudyKitPreparationData,
  softDeleteRestoreStudyKitPreparation,
  getStudyKitPreparationData,
  getStudyKitInventory,
  getStudyKitPreparationOverview
};

// Add New Kit Preparation
async function addNewStudyKitPreparation(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudyKitPreparation`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Kit Preparation
async function updateStudyKitPreparation(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudyKitPreparation`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Status Convert Kit Preparation
async function statusConvertKitPreparation(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}statusConvertKitPreparation`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Approved Dispatched Kit Preparation
async function approvedDispatchedKitPreparation(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}approvedDispatchedKitPreparation`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Delete Kit Preparation
async function deleteStudyKitPreparationData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudyKitPreparationData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Soft Delete & Restore Kit Preparation
async function softDeleteRestoreStudyKitPreparation(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudyKitPreparation`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Study Kit Preparation Overview
async function getStudyKitPreparationOverview(studyId, mode) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyKitPreparationOverview/${studyId}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Kit Preparation
async function getStudyKitPreparationData(studyId, status, mode, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyKitPreparationData/${studyId}/${status}/${mode}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyKitPreparationData/${studyId}/${status}/${mode}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Kit Inventory
async function getStudyKitInventory(studyId, status, mode, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyKitInventory/${studyId}/${status}/${mode}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyKitInventory/${studyId}/${status}/${mode}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}